import { useTranslation } from 'react-i18next'
import { FieldProps } from './constants'
import { useEffect } from 'react'

export const RandomField = ({ classifier, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, field: null }
  useEffect(() => {
    onChange({
      ...baseValue,
      field: '',
      fieldKey: '',
      name: `${t(classifier.name)} `,
    })
  }, [])

  return (
    <span>{t('noConfigReqLabel')}</span>
  )
}
